import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Share2, MessageCircle, Mail, MessageSquare } from "lucide-react";
import { toast } from "sonner";

// Reusable share panel: WhatsApp / SMS / Email / native-or-copy.
// Shares the offer link so a friend can download their own coupon.
export const ShareSheet = ({ open, onOpenChange, url, title, storeName }) => {
  const text = `Guarda questa offerta su KoupoNow: "${title || "Offerta"}"${storeName ? ` da ${storeName}` : ""}. Scaricala anche tu 👉 ${url}`;
  const close = () => onOpenChange(false);
  const wa = () => { window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank"); close(); };
  const sms = () => { window.location.href = `sms:?&body=${encodeURIComponent(text)}`; close(); };
  const email = () => { window.location.href = `mailto:?subject=${encodeURIComponent("Un'offerta per te su KoupoNow")}&body=${encodeURIComponent(text)}`; close(); };
  const more = async () => {
    if (navigator.share) { try { await navigator.share({ title: "KoupoNow", text, url }); close(); return; } catch (_) {} }
    try { await navigator.clipboard.writeText(url); toast.success("Link copiato negli appunti"); close(); } catch (_) {}
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm rounded-3xl" data-testid="share-dialog">
        <DialogHeader>
          <DialogTitle className="text-lg font-extrabold">Condividi questa offerta</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-500 -mt-1">Invita un amico: potrà scaricare il suo coupon. Il tuo codice resta privato.</p>
        <div className="space-y-2 mt-2">
          <button onClick={wa} data-testid="share-whatsapp" className="w-full flex items-center gap-3 h-12 rounded-xl bg-[#25D366]/10 hover:bg-[#25D366]/20 px-4 font-bold text-slate-800 transition-colors">
            <MessageCircle className="h-5 w-5 text-[#25D366]" /> WhatsApp
          </button>
          <button onClick={sms} data-testid="share-sms" className="w-full flex items-center gap-3 h-12 rounded-xl bg-slate-100 hover:bg-slate-200 px-4 font-bold text-slate-800 transition-colors">
            <MessageSquare className="h-5 w-5 text-slate-600" /> SMS
          </button>
          <button onClick={email} data-testid="share-email" className="w-full flex items-center gap-3 h-12 rounded-xl bg-slate-100 hover:bg-slate-200 px-4 font-bold text-slate-800 transition-colors">
            <Mail className="h-5 w-5 text-slate-600" /> Email
          </button>
          <button onClick={more} data-testid="share-more" className="w-full flex items-center gap-3 h-12 rounded-xl bg-slate-100 hover:bg-slate-200 px-4 font-bold text-slate-800 transition-colors">
            <Share2 className="h-5 w-5 text-slate-600" /> Altro / Copia link
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareSheet;
